import { PROVIDER_ROLE_CODING_MAP } from '@bariendo/lib/codings';
import { getPrimaryProviderRole } from '@bariendo/lib/profile';
import { PractitionerRole } from '@medplum/fhirtypes';

export function parseProviderRole(providerRole: PractitionerRole | undefined) {
  if (!providerRole) return undefined;

  const role = getPrimaryProviderRole(providerRole);

  if (!role) return undefined;

  return PROVIDER_ROLE_CODING_MAP[role];
}
